export const formatCurrency = (value: string): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(Math.ceil(Number.parseInt(value)));
};

export const formatCompact = (value: string): string => {
  return new Intl.NumberFormat("en", {
    notation: "standard",
  }).format(Math.ceil(Number.parseInt(value)));
};

// Used on /balance page TrendingGameTokens tiles
export const formatUSD = (amount: number | undefined) => {
  if (!amount) return "";
  if (amount < 0.01) return `$${amount.toFixed(6)}`;
  return `$${amount.toFixed(2)}`;
};

// Used on /tokens/:address page. Consider merging with formatUSD
export const formatUSDTokenDetails = (amount: number | undefined): string => {
  if (!amount) return "";

  const fixedDecimals = amount < 1 ? 4 : 2;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fixedDecimals,
    maximumFractionDigits: fixedDecimals,
  }).format(amount);
};

export const formatUSD24HrChange = (amount: number | undefined) => {
  if (!amount) return "";
  return `${amount.toFixed(2)}%`;
};

// Formats eth address as 0x00…0000
export const truncateEthAddress = (
  address: string,
  prefixLength = 4,
  suffixLength = 4,
) => {
  if (!address) return "";

  const regex = new RegExp(
    `^(0x[a-zA-Z0-9]{${prefixLength - 2}})[a-zA-Z0-9]+([a-zA-Z0-9]{${suffixLength}})$`,
  );
  const match = address.match(regex);

  if (!match) return address;
  return `${match[1]}…${match[2]}`;
};
